// DO NOT import the entire lodash library. Only functions needed

import {windowNavigator} from './window';
import logger from './log';
import bind from 'lodash/bind';
import merge from 'lodash/merge';
import max from 'lodash/max';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import trim from 'lodash/trim';
import forEach from 'lodash/forEach';
import extend from 'lodash/extend';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import isArguments from 'lodash/isArguments';
import isEqual from 'lodash/isEqual';
import toArray from 'lodash/toArray';
import values from 'lodash/values';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import isNil from 'lodash/isNil';
import isElement from 'lodash/isElement';
import debounce from 'lodash/debounce';
import has from 'lodash/has';
import startsWith from 'lodash/startsWith';
import intersection from 'lodash/intersection';
import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';

let _ = {
  max,
  merge,
  get,
  throttle,
  trim,
  bind,
  each: forEach,
  ext: merge,
  extend,
  isArray,
  isFunction,
  isObject,
  isArguments,
  toArray,
  values,
  identity,
  isEmpty,
  isEmptyObject: isEmpty,
  isString,
  isDate,
  isNumber,
  isElement,
  isNil,
  debounce,
  has,
  startsWith,
  intersection,
  cloneDeep,
  sortBy,
  isEqual
};

/* jshint ignore:start */
const ArrayProto = Array.prototype;
const nativeIndexOf = ArrayProto.indexOf;
const breaker = {};

_.isDefined = function (target) {
  return !_.isUndefined(target);
};

_.isUndefined = function (target) {
  return target === null || (typeof target === 'undefined');
};

_.include = function (obj, target) {
  var found = false;
  if (obj === null) {
    return found;
  }
  if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
    // eslint-disable-next-line
    return obj.indexOf(target) != -1;
  }
  _.each(obj, function (value) {
    if (found || (found = value === target)) {
      return breaker;
    }
  });
  return found;
};

_.includes = function (str, needle) {
  return str.indexOf(needle) !== -1;
};

_.timestamp = function () {
  if (Date.now && Date.now.toString && Date.now.toString().indexOf('native code') > -1) {
    return Date.now();
  } else {
    return +new Date();
  }
};

_.now = _.timestamp;

_.formatDate = function (d) {
  // YYYY-MM-DDTHH:MM:SS in UTC
  function pad (n) {
    return n < 10 ? '0' + n : n;
  }
  return (
    d.getUTCFullYear() +
    '-' +
    pad(d.getUTCMonth() + 1) +
    '-' +
    pad(d.getUTCDate()) +
    'T' +
    pad(d.getUTCHours()) +
    ':' +
    pad(d.getUTCMinutes()) +
    ':' +
    pad(d.getUTCSeconds())
  );
};

_.strip_empty_properties = function (p) {
  var ret = {};
  _.each(p, function (v, k) {
    if (_.isString(v) && v.length > 0) {
      ret[k] = v;
    }
  });
  return ret;
};

_.UUID = (function () {
  var T = function () {
    var d = 1 * new Date();
    var i = 0;
    // eslint-disable-next-line
    while (d == 1 * new Date()) {
      i++;
    }

    return d.toString(16) + i.toString(16);
  };

  var R = function () {
    return Math.random()
      .toString(16)
      .replace('.', '');
  };

  var UA = function () {
    var ua = windowNavigator.userAgent;
    var i;
    var ch;
    var buffer = [];
    var ret = 0;

    function xor (result, byte_array) {
      var j;
      var tmp = 0;
      for (j = 0; j < byte_array.length; j++) {
        tmp |= buffer[j] << (j * 8);
      }
      return result ^ tmp;
    }

    for (i = 0; i < ua.length; i++) {
      ch = ua.charCodeAt(i);
      buffer.unshift(ch & 0xff);
      if (buffer.length >= 4) {
        ret = xor(ret, buffer);
        buffer = [];
      }
    }

    if (buffer.length > 0) {
      ret = xor(ret, buffer);
    }

    return ret.toString(16);
  };

  return function () {
    var se = (screen.height * screen.width).toString(16);
    return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
  };
})();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
_.isBlockedUA = function (ua) {
  if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
    logger.warn('Blocked UA Agent:' + ua);
    return true;
  }
  return false;
};

/**
 *
 * @param {*} string
 * @returns {string}
 *
 * https://stackoverflow.com/a/6969486
 */
_.escapeRegExp = function (input) {
  if (!input) return input;
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
/**
 *
 * @param ua
 * @returns {boolean}
 */
_.isBlockedUAComplex = function (ua, customUA) {
  ua = ua || windowNavigator.userAgent;
  if (!ua) {
    return true;
  }
  // eslint-disable-next-line
  const defaultPattern = 'googlebot|Google favicon|Mediapartners-Google|AdsBot-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|PhantomJS|HeadlessChrome|Uptimebot|AmazonProductDiscovery|Chrome-Lighthouse';
  let botPattern='(' + defaultPattern;
  if (customUA && _.isArray(customUA) && customUA.length > 0) {
    customUA = customUA.map(c => _.escapeRegExp(c));
    botPattern += ('|' + customUA.join('|'));
  }
  botPattern += ')';

  var re = new RegExp(botPattern, 'i');
  if (re.test(ua)) {
    return true;
  } else {
    return false;
  }
};

_.aurycOverride = function (override) {
  let hash = ('' + window.location.hash).toLowerCase();
  return (hash && hash.length > 8 && hash.indexOf('aurycoverride') > -1 && hash.indexOf(override) > -1);
};

_.disableEvent = function (eventType) {
  if (__DEV__) { // only enable the feature in dev
    const disabled = _.aurycOverride(`d_${eventType}_`);
    if (disabled) console.log('Disable event: ' + eventType);
    return disabled;
  } else {
    return false;
  }
};

_.Diff = function (originalStr, newStr) {
  const maxlen = _.max([originalStr.length, newStr.length]);
  let ceiling = maxlen;
  let floor = 0;
  let cap = 0;
  let pos = 0;
  let chunkSize = 0;

  while (ceiling - floor > 15) {
    chunkSize = Math.round((ceiling - floor) / 2);
    pos = ceiling - chunkSize;
    if (originalStr.substr(0, pos) !== newStr.substr(0, pos)) ceiling = pos;
    else floor = pos;
  }
  let chopped = newStr.substr(floor);
  ceiling = chopped.length;
  while (ceiling - cap > 15) {
    chunkSize = Math.round((ceiling - cap) / 2);
    pos = ceiling - chunkSize;
    if (chopped.substr(chopped.length - pos) !== originalStr.substr(originalStr.length - pos)) {
      ceiling = pos;
    } else {
      cap = pos;
    }
  }
  return {s: floor, e: cap, v: newStr.substring(floor, newStr.length - cap)};
};

// useCapture could be a boolean or an object (that supports passive capturing)
// see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
_.addEventListener = function (elem, eventName, callback, useCapture) {
  if (eventName !== 'propertychange' && elem.addEventListener) {
    elem.addEventListener(eventName, callback, useCapture);
  } else if (elem.attachEvent) {
    elem.attachEvent('on' + eventName, callback);
  }
};

_.removeEventListener = function (elem, eventName, callback, useCapture) {
  if (elem.removeEventListener) {
    elem.removeEventListener(eventName, callback, useCapture);
  } else if (elem.detachEvent) {
    elem.detachEvent('on' + eventName, callback);
  }
};

_.inArray = function (e, obj) {
  let r = -1;
  for (var a in obj) {
    // eslint-disable-next-line
    if (obj[a] === e) r = a;
  }
  // eslint-disable-next-line
  return r != -1;
};

_.isValidColor = function (color) {
  return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
};

_.isEmail = function (value) {
  // eslint-disable-next-line
  let emailRegEx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
  return emailRegEx.test(value);
};

_.isLongNumber = function (value) {
  if (/^([0-9]){10,}$/.test(value)) {
    return true;
  }
  return false;
};

_.hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  }
};
_.addCssCls = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else if (!_.hasClass(el, className)) {
    el.className += ' ' + className;
  };
};

_.removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else if (_.hasClass(el, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    el.className = el.className.replace(reg, ' ');
  }
};

_.getObjectPropertyDescriptor = function (obj, property) {
  const objProp = Object.getOwnPropertyDescriptor(obj, property);
  if (objProp) {
    return objProp;
  } else {
    const prototype = Object.getPrototypeOf(obj);
    if (!prototype) {
      return null;
    }
    return _.getObjectPropertyDescriptor(prototype, property);
  }
};

_.wrapObjectPropertyValue = function (obj, property, fn) {
  const originalProperty = obj[property];
  if (!originalProperty) {
    return;
  }

  const desc = _.getObjectPropertyDescriptor(obj, property);
  if (!(desc && desc.writable === true && desc.value)) {
    return;
  }

  Object.defineProperty(obj, property, {
    value: function () {
      try {
        fn.apply(this, arguments);
      } catch (e) {
        if (__DEV__) {
          console.log('Exception caught in wrapping:', obj, property);
        }
      }
      originalProperty.apply(this, arguments);
    },
    configurable: desc.configurable,
    writable: desc.writable,
    enumerable: desc.enumerable
  });
};

export default _;



/** WEBPACK FOOTER **
 ** ./src/utils/lodash.js
 **/